import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Activity, RefreshCw } from 'lucide-react';
import AnalysisJobsList from '../components/analysis/AnalysisJobsList';
import type { AnalysisJobsListHandle } from '../components/analysis/AnalysisJobsList';

export default function AnalysisPage() {
    const { t } = useTranslation();
    const jobsListRef = useRef<AnalysisJobsListHandle>(null);

    const handleRefresh = () => {
        jobsListRef.current?.refresh();
    };

    return (
        <div className="space-y-6 animate-fade-in">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-50 text-primary-700 dark:bg-primary-900/30 dark:text-primary-300 flex items-center justify-center">
                        <Activity className="w-5 h-5" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                            {t('analysis.title')}
                        </h1>
                        <p className="text-gray-500 dark:text-gray-400">
                            {t('analysis.subtitle')}
                        </p>
                    </div>
                </div>

                <button
                    onClick={handleRefresh}
                    className="btn-secondary flex items-center gap-2"
                >
                    <RefreshCw className="w-5 h-5" />
                    {t('common.refresh')}
                </button>
            </div>

            {/* Info Card */}
            <div className="card p-6 bg-cream dark:bg-gray-800/50 border border-line dark:border-gray-700">
                <div className="flex items-start gap-4">
                    <Activity className="w-6 h-6 text-primary-600 flex-shrink-0 mt-1" />
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-white mb-2">
                            {t('analysis.complianceTitle')}
                        </h3>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                            {t('analysis.complianceDescription')}
                        </p>
                    </div>
                </div>
            </div>

            {/* Analysis Jobs List */}
            <div>
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
                    {t('analysis.jobsTitle')}
                </h2>
                <AnalysisJobsList ref={jobsListRef} autoRefresh={true} />
            </div>
        </div>
    );
}
